export const NETWORK_ERROR = 'NETWORK_ERROR';
export const API_ERROR = 'API_ERROR';
export const CUSTOM_ERROR = 'CUSTOM_ERROR';

export const CLEAR_ALERT = 'CLEAR_ALERT';

export const SUCCESS_ALERT = 'SUCCESS_ALERT';